module.exports = __webpack_public_path__ + "static/img/get_purse.35870040.png";